import { render, staticRenderFns } from "./AdminImportNewVehicles.vue?vue&type=template&id=66153d66&scoped=true&"
import script from "./AdminImportNewVehicles.vue?vue&type=script&lang=js&"
export * from "./AdminImportNewVehicles.vue?vue&type=script&lang=js&"
import style0 from "./AdminImportNewVehicles.vue?vue&type=style&index=0&id=66153d66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66153d66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66153d66')) {
      api.createRecord('66153d66', component.options)
    } else {
      api.reload('66153d66', component.options)
    }
    module.hot.accept("./AdminImportNewVehicles.vue?vue&type=template&id=66153d66&scoped=true&", function () {
      api.rerender('66153d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminImportNewVehicles.vue"
export default component.exports